export const formatEthRounded = (
  eth: string | number | bigint,
  digits: number,
) => {
  return `${parseFloat(eth.toString()).toFixed(digits)}`;
};
